/**
 * Atteniv wordmark, inlined from the marketing site's
 * `public/atteniv-logo-no-subtitle.svg`.
 *
 * The source asset hardcodes `fill="#16423c"` (the Atteniv brand teal). Here it
 * is rendered with `fill="currentColor"` so the mark inherits the sidebar's
 * text colour — legible on the dark sidebar, and automatically correct if the
 * sidebar theme ever changes.
 */
export const LogoFull = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 3171.43 728.73"
    role="img"
    aria-label="Atteniv"
    style={{ height: 28, width: 'auto', display: 'block' }}
  >
    <g transform="scale(8.571428571428571) translate(10, 10)">
      <g
        transform="matrix(5.079587936401367,0,0,5.079587936401367,-3.3525283821768865,-36.5730311714259)"
        fill="currentColor"
      >
        <path d="M2.74 20 l-2.08 0 l3.68 -12.78 l3.02 0 l3.7 12.78 l-2.1 0 l-1.08 -3.76 l-4.36 1.02 z M5.86 9.18 l-1.7 5.88 l3.16 -0.76 z M20.64 7.199999999999999 l0 2 l-3.12 0 l0 10.8 l-2 0 l0 -10.8 l-3.1 0 l0 -2 l8.22 0 z M30.160000000000004 7.199999999999999 l0 2 l-3.12 0 l0 10.8 l-2 0 l0 -10.8 l-3.1 0 l0 -2 l8.22 0 z M34.26 17.98 l5.42 0 l0 2 l-7.42 0 l0 -12.78 l6.96 0 l0 2 l-4.96 0 l0 2.96 l4.6 0 l0 2 l-4.6 0 l0 3.82 z M49.480000000000004 7.199999999999999 l2 0 l0 12.8 l-2.24 0 l-5.48 -9.26 l0 9.26 l-2 0 l0 -12.8 l1.1 0 l0.02 0 l1.12 0 l5.48 9.28 l0 -9.28 z M56.18 20 l-2 0 l0 -12.78 l2 0 l0 12.78 z M67.5 7.220000000000001 l2.02 0 c0.14 1.62 -0.06 3.26 -0.6 4.94 c-0.62 1.9 -1.56 3.56 -2.38 5 c-0.64 1.14 -1.16 2.08 -1.42 2.84 l-2.38 0 c-0.26 -0.76 -0.78 -1.7 -1.42 -2.84 c-0.84 -1.44 -1.78 -3.1 -2.38 -5 c-0.54 -1.68 -0.74 -3.32 -0.6 -4.94 l2 0 c-0.36 3.56 1.26 6.42 2.72 8.96 c0.3 0.54 0.6 1.06 0.86 1.58 c0.28 -0.52 0.58 -1.04 0.88 -1.58 c1.44 -2.54 3.06 -5.4 2.7 -8.96 z" />
      </g>
    </g>
  </svg>
);
